var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1514 9.45904L17.7016 1.23666C17.5736 0.510736 16.9423 0 16.2299 0C16.1436 0 3.53352 2.21555 3.53352 2.21555C2.71975 2.35906 2.17635 3.13509 2.31986 3.94886L2.45962 4.74156H13.8403C15.2841 4.74156 16.4587 5.91616 16.4587 7.35995V8.40918V10.9546V11.4531L17.9378 11.1923C18.7515 11.0488 19.2949 10.2728 19.1514 9.45904Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3362 12.0781H0V15.5052C0 16.3315 0.669897 17.0014 1.49622 17.0014H13.84C14.6664 17.0014 15.3362 16.3315 15.3362 15.5052V12.0781ZM4.45451 15.6534H1.90906C1.59921 15.6534 1.348 15.4021 1.348 15.0923C1.348 14.7824 1.59921 14.5312 1.90906 14.5312H4.45451C4.76436 14.5312 5.01558 14.7824 5.01558 15.0923C5.01558 15.4021 4.7644 15.6534 4.45451 15.6534Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 7.28679H15.3345C15.2964 6.49433 14.642 5.86353 13.8401 5.86353H1.49634C0.69447 5.86353 0.0400018 6.49433 0.00195312 7.28679Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.41016H15.3362V10.9556H0V8.41016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon2);
export default __webpack_public_path__ + "static/media/banner_icon2.c43ecfbfaf3004f1eef0e2d4094d57ae.svg";
export { ForwardRef as ReactComponent };